/**
 * Возвращает полный URL изображения.
 * Если path уже полный URL (http/https/data:) — возвращает как есть.
 * Иначе добавляет REACT_APP_STORAGE_URL.
 * Path segments are URI-encoded (spaces / Armenian filenames in category icons).
 */
export default function getImageUrl(path, defaultImg) {
    if (!path) return defaultImg ?? null;
    if (typeof path !== "string") return defaultImg ?? null;
    if (
        path.startsWith("http://") ||
        path.startsWith("https://") ||
        path.startsWith("data:")
    ) {
        return path;
    }
    const encoded = path
        .replace(/^\/+/, "")
        .split("/")
        .map((seg) => {
            try {
                return encodeURIComponent(decodeURIComponent(seg));
            } catch {
                return encodeURIComponent(seg);
            }
        })
        .join("/");
    return (process.env.REACT_APP_STORAGE_URL || "") + encoded;
}
